import { Navigate, RouteObject } from 'react-router-dom';

import { GatedEmbed } from 'play/pages/gated-embed/GatedEmbed';
import { AuthUserContextProvider } from 'support/auth/AuthUserContext';
import { Mode } from 'types/graphql';

import { NotificationsContainer } from './molecules/notifications-container/NotificationsContainer';
import { PlayAppContainer } from './PlayAppContainer';

export const playAppRoutes: RouteObject[] = [
  ...[
    // Embed
    { path: 'embed/:teamSlug/tracks/:trackSlug/*', mode: Mode.Embed },
    { path: 'embed/:teamSlug/invite/:inviteID/tracks/:trackSlug/*', mode: Mode.Embed },

    // Platform
    { path: ':teamSlug/tracks/:trackSlug/*', mode: Mode.Platform },
    { path: ':teamSlug/invite/:inviteID/tracks/:trackSlug/*', mode: Mode.Platform },

    // Deprecated ?
    { path: 'embed/:teamSlug/:trackSlug/*', mode: Mode.Embed },
    { path: 'embedv2/:teamSlug/tracks/:trackSlug/*', mode: Mode.Embed },
  ].map<RouteObject>(({ path, mode }) => ({
    path,
    element: (
      <>
        <PlayAppContainer mode={mode} />
        <NotificationsContainer />
      </>
    ),
    children: [
      // When track details page is moved into the lab, this embed check will not be required anymore
      ...(mode === Mode.Embed
        ? [
            {
              index: true,
              lazy: () =>
                import('./pages/splash-screen/SplashScreenContainer').then(({ SplashScreenContainer }) => ({
                  element: <SplashScreenContainer mode={mode} />,
                })),
            },
          ]
        : []),
      {
        path: 'challenges',
        children: [
          {
            index: true,
            lazy: () =>
              import('./pages/splash-screen/SplashScreenContainer').then(({ SplashScreenContainer }) => ({
                element: <SplashScreenContainer mode={mode} />,
              })),
          },
          {
            path: ':challengeSlug/*',
            children: [
              {
                index: true,
                lazy: () =>
                  import('./pages/splash-screen/SplashScreenContainer').then(({ SplashScreenContainer }) => ({
                    element: <SplashScreenContainer mode={mode} />,
                  })),
              },
              {
                path: 'notes',
                lazy: () =>
                  import('./pages/notes/NotesContainer').then(({ NotesContainer }) => ({
                    element: <NotesContainer mode={mode} />,
                  })),
              },
              {
                path: 'assignment',
                lazy: () =>
                  import('./pages/learn-environment/LearnEnvironment').then(({ LearnEnvironment }) => ({
                    element: <LearnEnvironment mode={mode} />,
                  })),
              },
              { path: '*', element: <Navigate to="." replace /> },
            ],
          },
        ],
      },
      {
        path: 'recap/*',
        lazy: () =>
          import('./pages/recap/Recap').then(({ RecapContainer }) => ({
            element: <RecapContainer mode={mode} />,
          })),
        children: [
          {
            index: true,
            lazy: () =>
              import('./organisms/review/TrackReviewRating').then(({ TrackReviewRating }) => ({
                element: <TrackReviewRating />,
              })),
          },
          {
            path: 'thanks',
            lazy: () =>
              import('./atoms/track-review-complete/TrackReviewComplete').then(({ TrackReviewComplete }) => ({
                element: <TrackReviewComplete />,
              })),
          },
          {
            path: 'review/:reviewID',
            lazy: () =>
              import('./organisms/review/TrackReviewFeedback').then(({ TrackReviewFeedback }) => ({
                element: <TrackReviewFeedback />,
              })),
          },
          { path: '*', element: <Navigate to="." replace /> },
        ],
      },
      { path: '*', element: <Navigate to="." replace /> },
    ],
  })),

  {
    path: 'embed/:teamSlug/invite/:inviteID',
    element: (
      <>
        <NotificationsContainer />
        <AuthUserContextProvider>
          <GatedEmbed />
        </AuthUserContextProvider>
      </>
    ),
  },
];
